import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { api, ApiError } from '@/lib/axios'
import { ApplicationAccountUserStatus } from '../models/applicationAccountUser'

type UpsertUserApplicationResponse =
  | { verifyToken: string; id: string }
  | {
      applicationId: string
      userId: string
      email: string
      displayName: string
      name: string
      documentNumber: string
      externalUserId: string | null
      role: string
      isNewUser: boolean
      id: string
      status: ApplicationAccountUserStatus
    }

type UpsertUserApplicationProps = {
  applicationId: string
  userId: string
  email: string
  displayName: string
  name: string
  documentNumber: string
  externalUserId: string | null
  role: string
  isNewUser: boolean
}

async function upsertUserApplicationRequest({
  applicationId,
  userId,
  ...body
}: UpsertUserApplicationProps) {
  const { data } = await api.backend.post<UpsertUserApplicationResponse>(
    `/application-account-users/upsert-user-application/${applicationId}/${userId}`,
    body,
  )
  return data
}

export function useUpsertApplicationAccountUser() {
  const { mutateAsync, isPending } = useMutation<
    UpsertUserApplicationResponse,
    AxiosError<ApiError>,
    UpsertUserApplicationProps
  >({
    mutationKey: ['/application-account-users/upsert-user-application'],
    mutationFn: upsertUserApplicationRequest,
  })

  const handleUpsertApplicationAccountUser = async (
    data: UpsertUserApplicationProps,
  ) => {
    return mutateAsync(data)
  }

  return { handleUpsertApplicationAccountUser, isUpserting: isPending }
}
